module.exports = {"421222100":"隽水镇","421222101":"麦市镇","421222102":"塘湖镇","421222103":"关刀镇","421222104":"沙堆镇","421222105":"五里镇","421222106":"石南镇","421222107":"北港镇","421222108":"马港镇","421222200":"四庄乡","421222201":"大坪乡","421222500":"鹿角山林场","421222501":"锡山森林公园管理处","421222502":"黄龙林场","421222503":"黄袍林场","421222504":"药姑林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421222.json
// module id = 1785
// module chunks = 0